export enum PlayerRankQueryKeys {
  Me = 'player-rank/me',
  ByPlayerId = 'player-rank/player/:id',
}
